import { Task } from '@/types/employee/task';
import dayjs from 'dayjs';

export const tasks: Task[] = [
  {
    id: 'TASK001',
    title: 'Fix leaking faucet in Unit 101',
    description: 'Resident reported a leaking faucet in the bathroom',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP001',
      name: 'Mike Johnson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    apartmentUnit: {
      id: 'UNIT001',
      name: 'Unit 101'
    },
    attachments: [
      {
        id: 'ATT001',
        name: 'Leak Photo',
        type: 'image/jpeg',
        size: 1024,
        path: '/documents/tasks/TASK001/leak.jpg',
        url: '/documents/tasks/TASK001/leak.jpg',
        uploadedAt: dayjs('2024-03-15').toDate()
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK002',
    title: 'Clean common area lobby',
    description: 'Daily cleaning of the main lobby area',
    type: 'cleaning',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP002',
      name: 'Sarah Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK003',
    title: 'Security patrol - Building A',
    description: 'Evening security patrol around Building A perimeter',
    type: 'security',
    status: 'pending',
    priority: 'high',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-21').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK004',
    title: 'Inspect fire extinguishers',
    description: 'Monthly inspection of all fire extinguishers in the building',
    type: 'inspection',
    status: 'in_progress',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-18').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK005',
    title: 'Replace light bulbs - Parking garage',
    description: 'Replace burnt out light bulbs in the parking garage',
    type: 'maintenance',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP001',
      name: 'Mike Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-17').toDate(),
    completedAt: dayjs('2024-03-17').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK006',
    title: 'Clean swimming pool area',
    description: 'Weekly cleaning of the swimming pool and surrounding area',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'Maria Garcia'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-22').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK007',
    title: 'Check HVAC system - Unit 205',
    description: 'Resident reported air conditioning not working properly',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP006',
      name: 'James Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    apartmentUnit: {
      id: 'UNIT205',
      name: 'Unit 205'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK008',
    title: 'Security camera maintenance',
    description: 'Check and clean all security cameras in the building',
    type: 'security',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-16').toDate(),
    completedAt: dayjs('2024-03-16').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK009',
    title: 'Inspect elevator systems',
    description: 'Monthly elevator safety inspection and maintenance',
    type: 'inspection',
    status: 'pending',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-23').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK010',
    title: 'Clean gym equipment',
    description: 'Daily cleaning and sanitization of gym equipment',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sarah Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK011',
    title: 'Fix broken window - Unit 312',
    description: 'Resident reported a cracked window in the living room',
    type: 'maintenance',
    status: 'pending',
    priority: 'medium',
    assignedTo: {
      id: 'EMP001',
      name: 'Mike Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-24').toDate(),
    apartmentUnit: {
      id: 'UNIT312',
      name: 'Unit 312'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK012',
    title: 'Night security patrol',
    description: 'Overnight security patrol of the entire property',
    type: 'security',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP007',
      name: 'Thomas Anderson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK013',
    title: 'Inspect electrical panels',
    description: 'Quarterly inspection of all electrical panels and circuits',
    type: 'inspection',
    status: 'completed',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-15').toDate(),
    completedAt: dayjs('2024-03-15').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK014',
    title: 'Clean laundry room',
    description: 'Weekly cleaning of the shared laundry room',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'Maria Garcia'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-25').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK015',
    title: 'Repair garage door',
    description: 'Fix malfunctioning garage door in parking area',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP006',
      name: 'James Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-21').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK016',
    title: 'Security gate maintenance',
    description: 'Check and repair the main security gate',
    type: 'security',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-18').toDate(),
    completedAt: dayjs('2024-03-18').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK017',
    title: 'Inspect plumbing systems',
    description: 'Annual inspection of all plumbing systems',
    type: 'inspection',
    status: 'pending',
    priority: 'medium',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-26').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK018',
    title: 'Clean community room',
    description: 'Daily cleaning of the community meeting room',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sarah Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK019',
    title: 'Fix balcony railing - Unit 408',
    description: 'Resident reported loose balcony railing',
    type: 'maintenance',
    status: 'pending',
    priority: 'high',
    assignedTo: {
      id: 'EMP001',
      name: 'Mike Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-22').toDate(),
    apartmentUnit: {
      id: 'UNIT408',
      name: 'Unit 408'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK020',
    title: 'Security alarm test',
    description: 'Monthly testing of all security alarms',
    type: 'security',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP007',
      name: 'Thomas Anderson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK021',
    title: 'Inspect roof condition',
    description: 'Annual roof inspection and maintenance check',
    type: 'inspection',
    status: 'completed',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-17').toDate(),
    completedAt: dayjs('2024-03-17').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK022',
    title: 'Clean storage units',
    description: 'Monthly cleaning of storage unit area',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'Maria Garcia'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-27').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK023',
    title: 'Repair kitchen sink - Unit 156',
    description: 'Resident reported clogged kitchen sink',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP006',
      name: 'James Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-21').toDate(),
    apartmentUnit: {
      id: 'UNIT156',
      name: 'Unit 156'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK024',
    title: 'Security lighting check',
    description: 'Check all exterior security lighting',
    type: 'security',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK025',
    title: 'Inspect fire alarm system',
    description: 'Monthly fire alarm system inspection',
    type: 'inspection',
    status: 'pending',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-28').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK026',
    title: 'Clean mail room',
    description: 'Daily cleaning of the mail room area',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sarah Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK027',
    title: 'Fix door lock - Unit 223',
    description: 'Resident reported malfunctioning door lock',
    type: 'maintenance',
    status: 'pending',
    priority: 'high',
    assignedTo: {
      id: 'EMP001',
      name: 'Mike Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-23').toDate(),
    apartmentUnit: {
      id: 'UNIT223',
      name: 'Unit 223'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK028',
    title: 'Security camera installation',
    description: 'Install new security cameras in parking area',
    type: 'security',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP007',
      name: 'Thomas Anderson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-25').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK029',
    title: 'Inspect water heater systems',
    description: 'Annual inspection of all water heater systems',
    type: 'inspection',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-16').toDate(),
    completedAt: dayjs('2024-03-16').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK030',
    title: 'Clean bike storage area',
    description: 'Weekly cleaning of the bike storage facility',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'Maria Garcia'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-29').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK031',
    title: 'Repair garbage disposal - Unit 189',
    description: 'Resident reported broken garbage disposal',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP006',
      name: 'James Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-22').toDate(),
    apartmentUnit: {
      id: 'UNIT189',
      name: 'Unit 189'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK032',
    title: 'Security patrol - Building B',
    description: 'Evening security patrol around Building B',
    type: 'security',
    status: 'completed',
    priority: 'high',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    completedAt: dayjs('2024-03-20').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK033',
    title: 'Inspect ventilation systems',
    description: 'Quarterly inspection of HVAC ventilation systems',
    type: 'inspection',
    status: 'pending',
    priority: 'medium',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-30').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK034',
    title: 'Clean pet area',
    description: 'Daily cleaning of the pet exercise area',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sarah Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK035',
    title: 'Fix shower drain - Unit 267',
    description: 'Resident reported slow draining shower',
    type: 'maintenance',
    status: 'pending',
    priority: 'medium',
    assignedTo: {
      id: 'EMP001',
      name: 'Mike Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-24').toDate(),
    apartmentUnit: {
      id: 'UNIT267',
      name: 'Unit 267'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK036',
    title: 'Security access control check',
    description: 'Test all access control systems and key cards',
    type: 'security',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP007',
      name: 'Thomas Anderson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-21').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK037',
    title: 'Inspect emergency exits',
    description: 'Monthly inspection of all emergency exits and signage',
    type: 'inspection',
    status: 'completed',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-18').toDate(),
    completedAt: dayjs('2024-03-18').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK038',
    title: 'Clean rooftop area',
    description: 'Monthly cleaning of rooftop common area',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'Maria Garcia'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-31').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK039',
    title: 'Repair dishwasher - Unit 334',
    description: 'Resident reported dishwasher not working',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP006',
      name: 'James Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-23').toDate(),
    apartmentUnit: {
      id: 'UNIT334',
      name: 'Unit 334'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK040',
    title: 'Security perimeter check',
    description: 'Daily security perimeter inspection',
    type: 'security',
    status: 'completed',
    priority: 'high',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    completedAt: dayjs('2024-03-20').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK041',
    title: 'Inspect smoke detectors',
    description: 'Monthly testing of all smoke detectors',
    type: 'inspection',
    status: 'pending',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-04-01').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK042',
    title: 'Clean computer room',
    description: 'Weekly cleaning of the business center computer room',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sarah Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK043',
    title: 'Fix ceiling fan - Unit 445',
    description: 'Resident reported ceiling fan making noise',
    type: 'maintenance',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP001',
      name: 'Mike Johnson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-25').toDate(),
    apartmentUnit: {
      id: 'UNIT445',
      name: 'Unit 445'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK044',
    title: 'Security training session',
    description: 'Monthly security staff training session',
    type: 'security',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP007',
      name: 'Thomas Anderson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-22').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK045',
    title: 'Inspect parking structure',
    description: 'Quarterly inspection of parking structure integrity',
    type: 'inspection',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK046',
    title: 'Clean conference room',
    description: 'Daily cleaning of the conference room',
    type: 'cleaning',
    status: 'pending',
    priority: 'low',
    assignedTo: {
      id: 'EMP005',
      name: 'Maria Garcia'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-04-02').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK047',
    title: 'Repair mailbox - Unit 512',
    description: 'Resident reported broken mailbox lock',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'medium',
    assignedTo: {
      id: 'EMP006',
      name: 'James Wilson'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-03-24').toDate(),
    apartmentUnit: {
      id: 'UNIT512',
      name: 'Unit 512'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK048',
    title: 'Security incident report review',
    description: 'Weekly review of security incident reports',
    type: 'security',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-21').toDate(),
    completedAt: dayjs('2024-03-21').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK049',
    title: 'Inspect water quality',
    description: 'Monthly water quality testing and inspection',
    type: 'inspection',
    status: 'pending',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Robert Taylor'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Lisa Davis'
    },
    dueDate: dayjs('2024-04-03').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK050',
    title: 'Clean art room',
    description: 'Weekly cleaning of the community art room',
    type: 'cleaning',
    status: 'completed',
    priority: 'low',
    assignedTo: {
      id: 'EMP002',
      name: 'Sarah Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'John Smith'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  }
]; 